import { useNotification } from "app/NotificationProvider";
import { analytics, AnalyticsEvents } from "common/analytics";
import EventFormDialog from "common/components/EventFormDialog";
import { useTranslation } from "common/locales";
import { useUpdateYieldEvent, YieldEvent } from "model";
import { useCurrentFarm } from "model/useFarmQueries";
import { Dispatch, SetStateAction, useRef } from "react";
import EnterYieldEvent from "./EnterYieldEvent";

export default function UpdateYieldEvent({
  yieldEvent,
  dialogOpen,
  setDialogOpen,
}: {
  yieldEvent: YieldEvent;
  dialogOpen: boolean;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}) {
  const { notify } = useNotification();
  const { t } = useTranslation();
  const updateYieldEventMutation = useUpdateYieldEvent();
  const dirtyRef = useRef(false);

  const handleClose = () => {
    setDialogOpen(false);
  };

  const { data: currentFarm } = useCurrentFarm();

  async function handleSave(yieldEvent: YieldEvent) {
    await updateYieldEventMutation.mutateAsync({
      yieldEvent,
      farmGuid: currentFarm?.guid ?? "",
    });
    notify(t("addYieldEvent.add.success"));
    analytics.track(AnalyticsEvents.YIELD_EVENT_UPDATED);
    handleClose();
  }
  return (
    <EnterYieldEvent
      yieldEvent={yieldEvent}
      handleSave={handleSave}
      dirtyRef={dirtyRef}
    >
      {({ steps, submitForm }) => (
        <EventFormDialog
          open={dialogOpen}
          onClose={handleClose}
          title={t("yieldEventInput.title")}
          onSave={submitForm}
          isDirty={() => dirtyRef.current}
          cancelAnalyticsEvent={AnalyticsEvents.YIELD_EVENT_UPDATE_CANCELLED}
          steps={steps}
        />
      )}
    </EnterYieldEvent>
  );
}
